import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
//import { useHistory } from 'react-router-dom';
import { AppBar, Toolbar, Grid, TextField } from '@material-ui/core';

import Box from '@material-ui/core/Box';
import SelectList from '../src/Models/PickList/SelectList'

const Languages = SelectList.i18n.Languages;
const drawerWidth = 240;
const userStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "#1867B8"
  },
  appBarShift: {
    width: 800,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  },
  headerImage: {
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  rightSection: {

    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  notificationIcon: {
    marginRight: theme.spacing(1)
  },
  userIcon: {
    marginRight: theme.spacing(1)
  },
  userName: {
    height: '100%',
    marginTop: theme.spacing(2)

  },
  titleBarDisplay: {
    backgroundColor: '#1867B8',
    color: '#fff',


  },

  logoutIcon: {
    color: '#fff',
    fontSize: '10px'
  },
  btnlogin: {
    marginRight:'20px',
    marginLeft:'20px',
    fontFamily: 'Open Sans',
  }
}));


const Header = () => {
  const classes = userStyles();
  //const history = useHistory();
  
  const [language, setlanguage] = useState('en')
  //const [isOpen, setOpenState] = React.useState(true);
  //const [open, setOpen] = React.useState(false);
  
  useEffect(() => {
    var selectedLanguge = localStorage.getItem('userlangugae');    
    if(selectedLanguge === null || selectedLanguge === 'undefined' ||selectedLanguge === ""){
    setlanguage('en');
    selectedLanguge = 'en';
    }else {
       setlanguage(selectedLanguge);
    }
    localStorage.setItem('userlangugae', selectedLanguge);

}, [language]);

  const handlelanguageChange = (e) => {       
   setlanguage(e.target.value)
   localStorage.removeItem('userlangugae');
   localStorage.setItem('userlangugae', e.target.value);

   window.location.reload(true);
  }


  return (
    <div>
      <Grid container >
        <Grid item xs={12}>
          <AppBar position="sticky" className={classes.appBar}>

            <Toolbar>
              {/* <Box ml={1}>
                <img src={guardianHeaderImage} className={classes.headerImage}  ></img>
              </Box> */}

              <div style={{ width: '100%' }}>
              <Box display="flex" flexDirection="row-reverse">               
                  <TextField
                    id="language-select"
                    select style={{ width: '150px',  marginRight: '20px',  paddingLeft: '10px', backgroundColor: 'white'}}
                    value={language}
                    onChange={handlelanguageChange}
                    SelectProps={{ native: true, }}>
                    { Object.keys(Languages).map((option) => (
                      <option key={option} value={option}>
                        { '  ' + Languages[option] }
                      </option>
                    ))}
                  </TextField>

                  
                </Box>

              </div>
            </Toolbar>


          </AppBar>
          <Grid>

          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}
export default Header;
